import script from "./processed.vue?vue&type=script&lang=ts&setup=true"
export * from "./processed.vue?vue&type=script&lang=ts&setup=true"

import "./processed.vue?vue&type=style&index=0&id=43db3e31&lang=scss"

const __exports__ = script;

export default __exports__